module.exports = __webpack_public_path__ + "static/media/spinner.cdae69e2.gif";